import DashboardLayout from "@/components/DashboardLayout";
import { FieldCalendar } from "@/components/field-calendar/FieldCalendar";
import { FieldCalendarErrorBoundary } from "@/components/field-calendar/FieldCalendarErrorBoundary";

/** Field operations calendar — edge-to-edge inside portal; uses normal page scroll. */
export default function FieldCalendarPage() {
  return (
    <DashboardLayout>
      <div
        className="-mx-4 w-[calc(100%+2rem)] sm:-mx-6 sm:w-[calc(100%+3rem)] lg:mx-auto lg:w-full lg:max-w-[min(100%,1400px)]"
        data-field-calendar-mode="mounted"
      >
        <FieldCalendarErrorBoundary section="Field Calendar">
          <FieldCalendar />
        </FieldCalendarErrorBoundary>
      </div>
    </DashboardLayout>
  );
}
